module.exports = __webpack_public_path__ + "img/cy.9f04989a.svg";